export const SEASON_IDS = ['halloween'] as const;

export type SeasonId = (typeof SEASON_IDS)[number];

export const isSeasonId = (value: unknown): value is SeasonId =>
  SEASON_IDS.includes(value as SeasonId);

/** Theme values a season overrides; components fall back to their default token when unset. */
export type SeasonalThemeOverrides = {
  searchCardActive: string;
};
